import '@shui/core/sh-menu-item';

import { Component, input, booleanAttribute, output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'sh-menu-item',
    template: '<ng-content />',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        '[attr.active]': 'active() ? "" : null',
        '[attr.checkbox]': 'checkbox() ? "" : null',
        '[attr.disabled]': 'disabled() ? "" : null',
        '[attr.expanded]': 'expanded() ? "" : null',
        '[attr.href]': 'href() ?? null',
        '[attr.icon]': 'icon() ?? null',
        '[attr.icon-color]': 'iconColor() ?? null',
        '[attr.icon-size]': 'iconSize() ?? null',
        '[attr.indeterminate]': 'indeterminate() ? "" : null',
        '[attr.label]': 'label() ?? null',
        '[attr.label-rows]': 'labelRows() ?? null',
        '[attr.toggle]': 'toggle() ? "" : null',
        '[attr.value]': 'value() ?? null',
        '[attr.vertical-alignment]': 'verticalAlignment() ? "" : null',
        '(clicked)': 'itemClicked.emit($event)',
        '(collapse)': 'collapse.emit($event)',
        '(expand)': 'expand.emit($event)'
    }
})
export class ShMenuItemComponent {
    /** If set to `true`, the style will adapt to represent that the item is currently active. */
    public readonly active = input(false, { transform: booleanAttribute });

    /** If set to `true`, checkbox will be added to menu item. */
    public readonly checkbox = input(false, { transform: booleanAttribute });

    /** If set, disabled styles will be applied */
    public readonly disabled = input(false, { transform: booleanAttribute });

    /**
     * If chapter is set to true, this will determine whether the chapter item is expanded or not.
     * This state switches upon clicking on the arrow.
     */
    public readonly expanded = input(false, { transform: booleanAttribute });

    /** Defines the destination link to be be navigated to when the item is clicked. */
    public readonly href = input<string | number | undefined>(undefined);

    /** Defines the icon shown before the label. For available icon list, refer Icon page. */
    public readonly icon = input<string | number | undefined>(undefined);

    /** Sets the color of icon added by setting icon property. */
    public readonly iconColor = input<string | number | undefined>(undefined);

    /**
     * Sets the icon size of icon component added through `icon` property. Possible values are `xs,
     * s, m, l`.
     */
    public readonly iconSize = input<string | number | undefined>(undefined);

    /**
     * Defines if a checkbox is indeterminate. If true, it will show a 'minus' icon in the checkbox
     * when checked instead of the tick icon.
     */
    public readonly indeterminate = input(false, { transform: booleanAttribute });

    /** Defines the label of the Menu Item. */
    public readonly label = input<string | number | undefined>(undefined);

    /** Label can have multiple lines when set. Possible values are `1,2 and auto`. */
    public readonly labelRows = input<string | number | undefined>(undefined);

    /** Toggles the active property on click event. */
    public readonly toggle = input(false, { transform: booleanAttribute });

    /** Defines the value of the Menu Item. */
    public readonly value = input<string | number | undefined>(undefined);

    /**
     * When vertical-alignment property is set, all items inside the menu item are vertical aligned.
     */
    public readonly verticalAlignment = input(false, { transform: booleanAttribute });

    public readonly itemClicked = output<Event>();

    public readonly collapse = output<Event>();

    public readonly expand = output<Event>();
}
